import React, { useCallback, useEffect, useMemo } from 'react';

import {
  Chip as ChipUI,
  Typography,
  Select,
  Input,
  MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

export default function Chip({ title, checkeds, getValue }) {
  const [data, setData] = React.useState(checkeds);

  const classes = useStyles();
  const optionsDefault = useMemo(
    () => [
      { id: 1, label: t('s.cadastro.usuario.leituratag') },
      { id: 2, label: t('s.cadastro.usuario.digitacaosemtag') },
      { id: 4, label: t('s.cadastro.usuario.digitacaocomtag') },
    ],
    []
  );

  const handleChangeValue = useCallback(({ target }) => {
    const { value } = target;

    if (!isEmpty(value)) setData(value);
  }, []);

  useEffect(() => {
    getValue(data);
  }, [data]);

  return (
    <S.Wrapper>
      <Typography>{title}</Typography>
      <Select
        multiple
        fullWidth
        variant="outlined"
        size="small"
        value={data}
        onChange={handleChangeValue}
        input={<Input />}
        InputLabelProps={{ shrink: true }}
        renderValue={(selected) => (
          <div className={classes.chips}>
            {selected
              .map((i) => optionsDefault.find((o) => o.id === i))
              .map((item) => (
                <ChipUI
                  key={item.id}
                  label={item.label}
                  className={classes.chip}
                />
              ))}
          </div>
        )}
      >
        {optionsDefault
          .filter((option) => !data.find((d) => d.id === option.id))
          .map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
      </Select>
    </S.Wrapper>
  );
}

Chip.propTypes = {
  title: PropTypes.string.isRequired,
  checkeds: PropTypes.arrayOf(PropTypes.any),
  getValue: PropTypes.func.isRequired,
};

Chip.defaultProps = {
  checkeds: [],
};
